module.exports = __webpack_public_path__ + "8-o2.jpg?ae0c77a2e97221a50979beff5cf7dfd3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/8-o2.jpg
// module id = 663
// module chunks = 0